import React from 'react';


export default function useNewMessages({ conversation, callback }) {
  const [ newMessages, setNewMessages ] = React.useState([]);

  React.useEffect(function() {
    function onNewMessage(newMessage) {
      setNewMessages(prevState => ([ ...prevState, newMessage ]));

      if (callback) {
        const recentMessage = {
          author:    newMessage.author,
          body:      newMessage.body,
          timestamp: newMessage.timestamp
        };
        callback({ recentMessage });
      }
    }

    if (conversation)
      conversation.on('messageAdded', onNewMessage);

    return function() {
      if (conversation)
        conversation.removeListener('messageAdded', onNewMessage);
    };
  }, [ conversation, callback ]);

  return newMessages;
}
